<!-- Main view/routes wrapper-->
<router-outlet></router-outlet>



// WEBPACK FOOTER //
// /app/src/app/app.component.html